import React from "react";
// material-ui
import { useTheme } from "@mui/material/styles";
import {
  useMediaQuery,
  Grid,
  List,
  ListItem,
  Stack,
  Typography,
  Chip,
} from "@mui/material";

// project import
import MainCard from "../../../../../components/MainCard";
import { ResumeTargetJob } from "../../../../../types/resumes-managment/resume";

// types

// ==============================|| EXPANDING TABLE - USER DETAILS ||============================== //

const ExpandingResumeTargetJobDetail = ({
  data,
}: {
  data: ResumeTargetJob;
}) => {
  const theme = useTheme();
  const matchDownMD = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Grid
      container
      spacing={3.5}
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Grid item xs={12} sm={7} md={12} xl={8.5}>
        <Stack spacing={2.5}>
          <MainCard title="Resume Target Job Details">
            <List sx={{ py: 0 }}>
              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">ID</Typography>
                      <Typography>{data.id}</Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">
                        Job Seeker Profile ID
                      </Typography>
                      <Typography>{data.job_seeker_profile_id}</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">
                        Job Availability ID
                      </Typography>
                      <Typography>{data.job_availability_id}</Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">Salary Expected</Typography>
                      <Typography>{data.salary_expected}</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">Currency</Typography>
                      <Typography>{data.currency}</Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">Confidential</Typography>
                      <Typography>{data.confidetial ? "Yes" : "No"}</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">Countries</Typography>
                      <Stack direction="row" spacing={1} flexWrap="wrap">
                        {data.countries && data.countries.length > 0 ? (
                          data.countries.map((country: any, index: number) => (
                            <Chip
                              key={index}
                              label={country.name || country}
                              size="small"
                              variant="outlined"
                            />
                          ))
                        ) : (
                          <Typography color="textSecondary">
                            No countries specified
                          </Typography>
                        )}
                      </Stack>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">Job Types</Typography>
                      <Stack direction="row" spacing={1} flexWrap="wrap">
                        {data.job_types && data.job_types.length > 0 ? (
                          data.job_types.map((jobType: any, index: number) => (
                            <Chip
                              key={index}
                              label={jobType.name || jobType}
                              size="small"
                              variant="outlined"
                            />
                          ))
                        ) : (
                          <Typography color="textSecondary">
                            No job types specified
                          </Typography>
                        )}
                      </Stack>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">Categories</Typography>
                      <Stack direction="row" spacing={1} flexWrap="wrap">
                        {data.categories && data.categories.length > 0 ? (
                          data.categories.map(
                            (category: any, index: number) => (
                              <Chip
                                key={index}
                                label={category.name || category}
                                size="small"
                                variant="outlined"
                              />
                            )
                          )
                        ) : (
                          <Typography color="textSecondary">
                            No categories specified
                          </Typography>
                        )}
                      </Stack>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>
              <ListItem divider={!matchDownMD}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">Created At</Typography>
                      <Typography>{data.created_at}</Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={0.5}>
                      <Typography color="secondary">Updated At</Typography>
                      <Typography>{data.updated_at}</Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </ListItem>
            </List>
          </MainCard>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default ExpandingResumeTargetJobDetail;
